import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
  required,
  maxLength,
  integer,
  minValue
} from "vuelidate/lib/validators";
import axios from "axios";
import ValidationService from "@/services/ValidationService";
import Select2Multiple from "v-select2-multiple-component";
import CONFIG from "@/assets/js/config.js";

export default {
  name: "ItemCreate",
  components: {
    MainLayout,
    Select2Multiple,
  },

  mixins: [ValidationService],

  data() {
    return {
      itemData: {
        p_item_name: null,
        p_item_amount: null,
        acd_year_id: '',
        transaction_category_id: '',
      },
      submitted: false,
      disabled: false,
      itemExists: false,
      acdYearArr: [],
      transactionCategoryArr: [],
      CONFIG
    };
  },

  validations: {
    itemData: {
      p_item_name: {
        required,
        maxLength: maxLength(100)
      },
      p_item_amount: {
        required,
        integer,
        maxLength: maxLength(9),
        minValue: minValue(1)
      },
      acd_year_id: {
        required,
        integer,
        minValue: minValue(1),
      },
    },
  },

  watch: {
    "itemData.acd_year_id"() {
      this.validationErrors.acd_year_id = [];
    }
  },

  methods: {
    getAcademicYear() {
      axios.get("period/periodList")
        .then(res => {
          this.acdYearArr = res.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getTransactionCategories() {
      axios.get(`/transactionCategory/getTransactionCategoryArray?type=${CONFIG.TRANSACTION_TYPE.INCOME}`)
        .then(res => {
          const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
          this.transactionCategoryArr = [
            { id: 0, text: 'Select Transaction Category' },
            ...categoryList.map((category) => ({
              id: category.id,
              text: category.text ?? category.category_name ?? "",
            }))
          ];
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    async checkDuplicateItem() {
        try {
            const response = await axios.get("/item/checkDuplicateItem", {
                params: {
                    item_name: this.itemData.p_item_name,
                },
            });
            this.itemExists = response.data.exists;
            this.submitted = false;
            this.disabled = false;
        } catch (error) {
            console.error('An error occurred:', error);
        }
    },

    async confirmRegister() {
      if (this.disabled) return;
      this.submitted = true;
      this.disabled = true;
      this.create();
    },

    async create() {
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }
      this.submitted = false;
      await this.checkDuplicateItem();
      if (this.itemExists) {
        this.$notification.error("Payment Item Name is already exist.", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }
      this.isLoading = true;
      this.itemData.loginID = this.$store.state.user.id;
      const payload = {
        ...this.itemData,
        transaction_category_id: this.itemData.transaction_category_id && this.itemData.transaction_category_id !== 0
          ? this.itemData.transaction_category_id
          : 0,
      };
      axios.post('item/create', payload)
        .then(res => {
          if (res.data.success === true) {
            this.$notification.success("Item Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'itemList'
            })
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            })
          }
        }).catch(error => {
          if (error.response?.status === 422) {
            this.printValidationError(error.response);
          } else {
            this.printValidationError(error.response);
          }
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        }).finally(() => {
          this.disabled = this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getAcademicYear();
    this.getTransactionCategories();
  },
};
